import EmissionCarPermissions from './EmissionCarPermissions'
import EmissionHomePermissions from './EmissionHomePermissions'
import EmissionCommercePermissions from './EmissionCommercePermissions'
import EmissionConsortiumPermissions from './EmissionConsortiumPermissions'
import EmissionMotorcyclePermissions from './EmissionMotorcyclePermissions'
import EmissionLifePermissions from './EmissionLifePermissions'
import EmissionBicyclePermissions from './EmissionBicyclePermissions'
import EmissionComputerPermissions from './EmissionComputerPermissions'
import EmissionPhonePermissions from './EmissionPhonePermissions'
import EmissionMobilityPermissions from './EmissionMobilityPermissions'
import EmissionLoanPermissions from './EmissionLoanPermissions'

class EmissionPermissions {
    constructor({ 
        car, 
        home, 
        commerce, 
        consortium, 
        motorcycle,
        life,
        bicycle,
        computer,
        phone,
        mobility,
        loan,
    } = {}) {
        this.car = new EmissionCarPermissions(car)
        this.motorcycle = new EmissionMotorcyclePermissions(motorcycle)
        this.home = new EmissionHomePermissions(home)
        this.commerce = new EmissionCommercePermissions(commerce)
        this.consortium = new EmissionConsortiumPermissions(consortium)
        this.life = new EmissionLifePermissions(life)
        this.bicycle = new EmissionBicyclePermissions(bicycle)
        this.computer = new EmissionComputerPermissions(computer)
        this.phone = new EmissionPhonePermissions(phone)
        this.mobility = new EmissionMobilityPermissions(mobility)
        this.loan = new EmissionLoanPermissions(loan)
    }
}

export default EmissionPermissions
